<template>

  <div class="comments">
    <!-- 提现 -->
    <van-row>
      <van-col span="22" offset="1" class="my_withdrawal">
        <van-col span="6" class="my_withdrawal_name"> {{ $t('column.Receiving_account')}}： </van-col>
        <van-col span="18" class="my_withdrawal_name_val" @click="user_account_btn"> {{ list.account | get_account(this,$t) }}</van-col>
        <van-col span="24" class="my_withdrawal_name_number" v-if="list.account_name">  {{ list.account_name }} ({{ list.account_number }}) </van-col>
        <van-col span="24" class="my_withdrawal_name_tx">  {{ $t('column.Withdrawal_amount')}}：  </van-col>
        <van-col span="24" class="my_withdrawal_money">
          <van-field v-model="withdrawal" type="number" :label="$t('other.money')" :placeholder="$t('placeholder.Input_withdrawal_amount')"/>
        </van-col>
      </van-col>
       <van-col span="24" class="my_withdrawal_name_bor">  </van-col>
      <van-col span="22" offset="1" class="my_withdrawal_res">{{ $t('other.Current_withdrawal_amount')}} {{ list.money }} {{ $t('other.yuan')}}</van-col>
      <van-col span="18" offset="3" class="my_withdrawal_res_btn">
        <van-button type="primary" size="large" class="my_information_btn" @click="withdrawal_btn" safe-area-inset-bottom>{{ $t('btn.Withdrawal')}}</van-button>
      </van-col>
      <van-action-sheet v-model="drawer">
        <van-picker
          safe-area-inset-bottom
          :title="$t('column.Select_withdrawal_account')"
          show-toolbar
          :columns = 'pay_list'
          @confirm = 'onConfirmbank'
          @cancel = 'onChangebank'
          :confirm-button-text="$t('btn.submit')"
          :cancel-button-text="$t('btn.cancel')"
        />
      </van-action-sheet>
    </van-row>

  </div>
</template>
<script>
  //请求接口组件
  import '@/assets/css/style.css'
  import axios from 'axios'
  import { Toast } from 'vant';
  export default {
    filters: {
      get_account(val,t) {
        return val ? val : t.$t('column.Select_withdrawal_account')
      }
    },
    data:function() {
      return {
        user_account: false,
        withdrawal: '',
        list:{},
        pay_list: [],
        drawer:false
      }
    },
    created: function() {
      this.convert();
      document.title = this.$t('title.withdrawal')
    },
    methods: {
      // 选择银行卡
      onConfirmbank (item) {
        let i = item.value
        if (i == 0) {
          const uid = this.$route.query.uid
          const token = this.$route.query.token
          this.$router.push({path:'/add_bank',query:{uid:uid, token: token }});
        } else {
          console.log(item)
          this.list.account_id = item.id
          this.list.account = item.account
          this.list.account_number = item.account_number
          this.list.account_name = item.account_name
        }
        this.drawer = false
      },
      onChangebank () {
        this.drawer = false
      },
      // 选择账号
      user_account_btn() {
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        const Add_withdrawal = this.$t('Tips.Add_withdrawal_account')
        axios.get(this.baseUrlApi+"mapi/public/index.php/api/Userinfo_api/sel_user_cash_account",{ params:{ uid:uid,token:token }}).then(res =>{
          this.list.pay_list = res.data.list
          console.log(this.list.pay_list);

          this.pay_list = [{'text': Add_withdrawal, 'value': 0,'id':0,'account':'','account_name':'','account_number':'' }];
          for (let i=0;i< this.list.pay_list.length; i++){
            const item={'text':this.list.pay_list[i].account +' (' + this.list.pay_list[i].name + ')', 'id': this.list.pay_list[i].id, 'account': this.list.pay_list[i].account, 'account_name': this.list.pay_list[i].name, 'account_number': this.list.pay_list[i].account_number }
            this.pay_list.push(item);
          }
          console.log(this.pay_list)
        })
        this.drawer = true
      },
      convert: function() {
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;

        axios.get(this.baseUrlApi+"mapi/public/index.php/api/Userinfo_api/vue_earnings",{ params:{ uid:uid,token:token }}).then(res =>{
          this.list = res.data.data
          console.log( this.list)
        })
      },
      // 提现
      withdrawal_btn(){
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        const bankid =  this.list.account_id
        if(!bankid){
          Toast(this.$t('Tips.Select_withdrawal_account'));
          return;
        }
        if(this.withdrawal > this.list.money){
          Toast(this.$t('Tips.Insufficient_Balance'));
          return;
        }
         axios.get(this.baseUrlApi+"mapi/public/index.php/api/Userinfo_api/vue_cash_income",{ params:{ uid:uid,token:token, income: this.withdrawal,bankid:bankid }}).then(res =>{
          console.log(res.data.data)
           Toast(res.data.msg)
          if (res.data.code === 1) {
            this.convert()
          }
        })


      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/withdrawal.vue